import React from "react";
import { ClayRadio, ClayRadioGroup } from "@clayui/form";
import { useModal } from "@clayui/modal";
import Loading from "../../../common/components/Loading";
import AlertModal from "../../../common/components/AlertModal";
import FormsGeneric from "../FormsGeneric";
import classNames from "classnames";
import { getPageLayoutType, getSignedIdStatus } from "../../../common/utils/utilsFunc";
import IngressoRectAndSolicitContextProvider, {
  ACTIONS,
  IngressoRectAndSolicitContext,
} from "../context/IngressoRecAndSolicitContextProvider";
import { CGE } from "../../../common/components/CGE";

const MERCHANDISE_CLAIM_CODE = "ZR0000100010";
const GREATER_AMOUNT = "mayor_a_40000";
const DUPLICATE_CLAIM_RESPONSE_CODE = 2;

const IngressoReclamoController = ({
  titleReclamo,
  codigo_empresa,
  textFetchError,
  url,
  solicitud,
  props
}) => {
  const [loading, setLoading] = React.useState(false);
  const [valueRadio, setValueRadio] = React.useState("");
  const [inputIdClient, setInputIdClient] = React.useState();
  const [jsonForm, setJsonForm] = React.useState();
  const [state, dispatch] = React.useContext(IngressoRectAndSolicitContext);
  const [error, setError] = React.useState("")
  const [visibleModalError, setVisibleModalError] = React.useState(false);
  const [valueExist, setValueExist] = React.useState({})
  const [detailClient, setDetailClient] = React.useState([])
  const { observer, onClose } = useModal({
    onClose: () => setVisibleModalError(false),
  });

  React.useEffect(() => {
    if(state.userAttributes && state.allComuna){
      // eslint-disable-next-line no-undef
      Liferay.Service(
        '/user/get-user-by-email-address',
        {
          // eslint-disable-next-line no-undef
          companyId: Liferay.ThemeDisplay.getCompanyId(),
          // eslint-disable-next-line no-undef
          emailAddress: Liferay.ThemeDisplay.getUserEmailAddress()
        },
        function(obj) {
          setValueExist({
            rut : obj.screenName,
            nombre: state.userAttributes.given_name,
            apelidoParterno: state.userAttributes.family_name,
            apelidoMaterno: state.userAttributes["custom:second_family_name"],
            comuna: state.userAttributes["custom:address_commune"],
            calle: state.userAttributes["custom:address_street"],
            num: state.userAttributes["custom:address_number"],
            blockDpto: state.userAttributes["custom:address_building"],
            email: state.userAttributes["email"],
            telefono: state.userAttributes["custom:house_phone_number"]
          })
        }
      );
    }
  },[state.userAttributes]);
  
  let optionsInteraction = [];
  let allComunas = [];
  optionsInteraction = [
    {
      label: "[Seleccione una opción]",
      value: "0",
    },
  ];

  if (state.listInteraction?.code === 0) {
    let data = state.listInteraction?.tipoSolicitud;
    if (valueRadio === "RC") {
      data.forEach((item) => {
        if(item.tipo == "RC")
          optionsInteraction.push({ label: item.nombre, value: item.codigo });
      });
    } else if (valueRadio === "RI") {
      data.forEach((item) => {
        if(item.tipo == "RI")
          optionsInteraction.push({ label: item.nombre, value: `${item.codigo}-${item.id}` });
      });
    }
  }

  allComunas = [
    {
      label: "[Seleccione Comuna]",
      value: 0,
    },
  ];

  if (state.allComuna?.code === 0) {
    let dataAllComunas = state.allComuna?.comunas;
    dataAllComunas?.forEach((item) => {
      allComunas.push({ label: item.nomComuna, value: item.codigoSAP });
    });
  }

  React.useEffect(() => {
    setLoading(true);
    dispatch({
      payload: true,
      type: ACTIONS.SET_LOAD_PAGE,
    });
  }, []);

  React.useEffect(() => {
    setLoading(true);
    if (valueRadio) {
      dispatch({
        payload: valueRadio,
        type: ACTIONS.SET_TAG_CURRENT_INTERACTION,
      });
    }
  }, [valueRadio]);

  React.useEffect(() => {
    setLoading(false);
  }, [state.listInteraction]);

  React.useEffect(() => {
    if (state.comuna && state.idList) {
      setLoading(false);
    }
  }, [state.comuna && state.idList]);

  React.useEffect(() => {
    if (inputIdClient) {
      setLoading(true);
    }
    dispatch({
      payload: inputIdClient,
      type: ACTIONS.SET_IDCLIENT,
    });
  }, [inputIdClient]);

  React.useEffect(() => {
    const detailClient = state.detailClient?.ConsultarDetalleCtaCtoResponse
    if (state.detailClient) {
      setInputIdClient("");
      if(detailClient?.RETORNO?.RETURN === 0  && detailClient?.ITEM?.SOCIEDAD === codigo_empresa) {
        setDetailClient(detailClient?.ITEM)
        setVisibleModalError(false);
        setError(null)
      } else if (detailClient?.RETORNO?.RETURN !== 0 || state.detailClient?.status || detailClient?.ITEM?.SOCIEDAD !== codigo_empresa) {
        setVisibleModalError(true);
        setDetailClient([])
        setError(detailClient?.RETORNO?.TEXTO_RETURN ? detailClient?.RETORNO?.TEXTO_RETURN : textFetchError)
        setInputIdClient("");
      } 
    }
    if (state.detailClient) {
      setLoading(false);
    }
  }, [state.detailClient]);

  React.useEffect(() => {
    if (jsonForm) {
      setLoading(true);
      if (valueRadio === "RC") {
        const isContingencyMerchandiseClaim = state.listInteraction?.contingencyEvent === true
          && jsonForm.CdgTipoReclamo === MERCHANDISE_CLAIM_CODE;
        const jsonDocuments = {
          cedulaIdentidad: jsonForm.CedulaIdentidad ? jsonForm.CedulaIdentidad : '',
        };

        if (!isContingencyMerchandiseClaim || jsonForm.EstimacionMontoAfectacion === GREATER_AMOUNT) {
          jsonDocuments.cotizacion = jsonForm.Cotizacion ? jsonForm.Cotizacion : '';
        }

        if (!isContingencyMerchandiseClaim) {
          jsonDocuments.informeTecnico = jsonForm.InformeTecnico ? jsonForm.InformeTecnico : '';
          jsonDocuments.fotoUno = jsonForm.FotoUno ? jsonForm.FotoUno : '';
          jsonDocuments.fotoDos = jsonForm.FotoDos ? jsonForm.FotoDos : '';
          jsonDocuments.fotoTres = jsonForm.FotoTres ? jsonForm.FotoTres : '';
        }

        let jsonReclamo =[ 
          {
          apellido1: jsonForm.lastName ? jsonForm.lastName : '',
          apellido2: jsonForm.motherLastName ? jsonForm.motherLastName : '',
          calle: jsonForm.CalleReclamante ? jsonForm.CalleReclamante : '',
          calleServicio: detailClient?.CALLE ? detailClient?.CALLE : '',
          canal: getPageLayoutType() ? "ZOV" : "URL",
          comuna: jsonForm.ComunaReclamante ? jsonForm.ComunaReclamante : '',
          comunaServicio: detailClient?.COMUNA ? detailClient?.COMUNA : '',
          cuentaContrato: jsonForm.CuentaContrato ? jsonForm.CuentaContrato : '',
          depto: jsonForm.blockOrDptoReclamante ? jsonForm.blockOrDptoReclamante : '',
          deptoServicio: `${detailClient?.SUPLEMENTO ? `${detailClient?.SUPLEMENTO} ` : ''}${detailClient?.PISO ? detailClient?.PISO : ''}`,
          descripcion:  ' Fecha del evento: ' + (jsonForm.Fecha ? jsonForm.Fecha + ' ' : '') + (jsonForm.Observacion ? jsonForm.Observacion : '') ,
          estimacionMontoAfectacion: isContingencyMerchandiseClaim ? jsonForm.EstimacionMontoAfectacion : '',
          empresa: codigo_empresa ? codigo_empresa : '',
          instalacion: jsonForm.Instalacion ? jsonForm.Instalacion : '',
          mail: jsonForm.EmailReclamante ? jsonForm.EmailReclamante : '',
          motivo: jsonForm.CdgTipoReclamo ? jsonForm.CdgTipoReclamo : '',
          nombre: jsonForm.NombReclamante ? jsonForm.NombReclamante : '',
          numero: jsonForm.NroCalleReclamante ? jsonForm.NroCalleReclamante : '',
          numeroServicio: detailClient?.NUMERO_CASA ? detailClient?.NUMERO_CASA : '',
          rut: jsonForm.RUTReclamante ? jsonForm.RUTReclamante : '',
          signedIn: getSignedIdStatus(),
          solicitud: false,
          telefono: jsonForm.TelefReclamante ? jsonForm.TelefReclamante : '',
          tipo: "R",
          url: url ? url : '',
        },
        jsonDocuments
      ]
        dispatch({
          payload: jsonReclamo,
          type: ACTIONS.SET_FORMCONT,
        });
      }
      if (valueRadio === "RI") {
        jsonForm.Calle = detailClient?.CALLE ? detailClient?.CALLE : '';
        jsonForm.Comuna = detailClient?.COMUNA ? detailClient?.COMUNA : '';
        jsonForm.NroCalle = detailClient?.NUMERO_CASA ? detailClient?.NUMERO_CASA : '';
        
        const jsonEntries = Object.entries(jsonForm);
        const filteredJson = jsonEntries.filter(function ([key, value]) {
          return (
            //key !== "CalleReclamante" &&
            // key !== "ComunaReclamante" &&
            // key !== "NroCalleReclamante" &&
            // key !== "motherLastName" &&
            //key !== "blockOrDptoReclamante" &&
            key !== "socialReason"
            // key !== "lastName"
          );
        });
        const newJson = Object.fromEntries(filteredJson);
        dispatch({
          payload: newJson,
          type: ACTIONS.SET_FORMCONT,
        });
      }

    }

  }, [jsonForm]);

  React.useEffect(() => {
    if (state.responseFormCont) {
      if (state.responseFormCont?.code === 0
        || state.responseFormCont?.code === DUPLICATE_CLAIM_RESPONSE_CODE) {
        setLoading(false);
        setVisibleModalError(true);
        setDetailClient([])
        setError(null)
      } else if (state.responseFormCont?.code !== 0 || state.responseFormCont?.status) {
        setError(state.responseFormCont?.mensaje ? state.responseFormCont?.mensaje : textFetchError)
        setLoading(false);
        setVisibleModalError(true);
      }
    }
  }, [state.responseFormCont]);

  return (
    <CGE.Panel
      title={`${titleReclamo} ${getPageLayoutType() ? "Oficina Virtual" : ""}`}
      description="Seleccione el motivo de su reclamo"
    >
      <div id="content-forms-reclamo" className="">
        <div>
          <ClayRadioGroup
            className="ClayRadioGrup"
            inline
            onSelectedValueChange={(val) => setValueRadio(val)}
            selectedValue={valueRadio}
          >
            <ClayRadio label="Comercial" value="RC" />
            <ClayRadio label="Ingresa tu emergencia eléctrica" value="RI" />
          </ClayRadioGroup>
        </div>
        {valueRadio && (
          <>
            <FormsGeneric
              props={props}
              tag={valueRadio}
              setInputIdClient={setInputIdClient}
              setForm={setJsonForm}
              state={state}
              setNumberFirst={
                detailClient ? detailClient?.PRIMER_NOMBRE_PERSONA : ""
              }
              setNumberSecond={
                detailClient ? detailClient?.SEGUNDO_NOMBRE_PERSONA : ""
              }
              setNumberLast={
                detailClient ? detailClient?.APELLIDO_PERSONA : ""
              }
              setComuna={detailClient ? detailClient?.COMUNA : ""}
              setCalle={detailClient ? detailClient?.CALLE : ""}
              setNroCalle={detailClient ? detailClient?.NUMERO_CASA : ""}
              setDpto={detailClient ? detailClient?.SUPLEMENTO : ""}
              setPiso={detailClient ? detailClient?.PISO : ""}
              setRut={detailClient ? detailClient?.RUT : ""}
              setInstalacion={detailClient ? detailClient?.INSTALACION : ""}
              setInstalacionComercial={
                detailClient ? detailClient?.INTERLOCUTOR_COMERCIAL : ""
              }
              sociedad={codigo_empresa}
              error={error}
              detailClient={detailClient}
              visibleModalError={visibleModalError}
              optionsInteraction={optionsInteraction}
              allComunas={allComunas}
              solicitud={solicitud}
              setDetailClient={setDetailClient}
              valueExist={valueExist}
            />
            {loading && <Loading />}
            {visibleModalError && (
              <AlertModal
                titleModal={error
                  ? "Advertencia"
                  : state.responseFormCont?.code === DUPLICATE_CLAIM_RESPONSE_CODE
                    ? "Información"
                    : "Confirmación"}
                msgModal={error ? error : state.responseFormCont?.mensaje}
                observer={observer}
                onClose={() => {
                  onClose()
                  window.scroll({
                    top: 0
                  });
                }}
                status={
                  state.responseFormCont?.code === 0
                    ? "success"
                    : state.responseFormCont?.code === DUPLICATE_CLAIM_RESPONSE_CODE
                      ? "info"
                      : "warning"
                }
              />
            )}
          </>
        )}
      </div>
    </CGE.Panel>
  );
};

const IngressoReclamoControllerWithProvider = ({
  tag,
  textFetchError,
  textLoadingBoleta,
  textFetchNoId,
  textAlertExcel,
  textAlertFilledField,
  setInputIdClient,
  setForm,
  titleReclamo,
  codigo_empresa,
  url,
  solicitud,
  props
}) => (
  <IngressoRectAndSolicitContextProvider>
    <IngressoReclamoController
      tag={tag}
      textFetchError={textFetchError}
      textLoadingBoleta={textLoadingBoleta}
      textFetchNoId={textFetchNoId}
      textAlertExcel={textAlertExcel}
      textAlertFilledField={textAlertFilledField}
      setInputIdClient={setInputIdClient}
      setForm={setForm}
      titleReclamo={titleReclamo}
      codigo_empresa={codigo_empresa}
      url={url}
      solicitud={solicitud}
      props={props}
    />
  </IngressoRectAndSolicitContextProvider>
);
export default IngressoReclamoControllerWithProvider;
